import { gql } from '@apollo/client';

import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLWebhookFleetRequester {
  private queryGetFleetProductType = gql`
    query getFleetProductTypeForWebhooks {
      safetyRankingProductType {
        productType
      }
    }
  `;

  public getFleetProductType = (): Promise<string | null> =>
    graphQLRequester
      .query<{ safetyRankingProductType: { productType: string } | null }>({
        query: this.queryGetFleetProductType,
      })
      .then((result) => result.safetyRankingProductType?.productType ?? null);
}

export default GraphQLWebhookFleetRequester;
